import { useContext } from 'react';
import { AudioContext } from '../contexts/AudioContext';
import AudioManager from '../services/AudioManager';

export const useAudioManager = (): AudioManager => {
  const audioManager = useContext(AudioContext);
  if (!audioManager) {
    throw new Error('useAudioManager must be used within an AudioProvider');
  }
  return audioManager;
};
